<template>                                
    <v-flex xs12 lg10 offset-lg1    >
        <v-container
        id="scroll-target"
        style="max-height: 60vh"
        class="scroll-y"
        fluid        
        >               
        <v-expansion-panel v-model="panelIndex">
            <v-expansion-panel-content
            v-for="(item, index) in facturas"
            :key="index"
            >
            <template v-slot:header>
                <div v-if="item.tipo != 'Tarea'">{{item.tipo == 'Factura Alb.' ? 'Albarán' : item.tipo == 'Recepcion' ? 'Recepción' : item.tipo}} <span class="primaryText">{{item.numero}}</span> <br> 
                    <span class="greytext">{{item.NombreClienteFact}}</span><br>
                    <span class="greytext" v-if="item.direccionEnvio">{{item.direccionEnvio}}</span><br> 
                    {{item.dia}}/{{item.mes}}/{{item.año}} 
                    <span class="bold-text" v-if="(item.tipo == 'Factura') && (item.pendiente > 0)">{{parseFloat(item.pendiente).toFixed(2)}} €</span>     
                    <span class="italic" v-if="(item.tipo == 'Factura') && (item.pendiente > 0) && (item.pendiente != item.importeTAX)"> Total: {{parseFloat(item.importeTAX).toFixed(2)}} €</span>   
                    
                    <v-text-field @click.stop="" v-if="item.mail" v-model="$store.state.usuario.lastEmail" label="Email" type="text"></v-text-field>                                            
                    <v-btn @click.stop="mailclick(item)" class="emailbtn" icon ripple v-if="!item.mail">
                        <v-icon color="grey lighten-1">email</v-icon>
                    </v-btn>           
                    <v-btn @click.stop="sendclick(item)" class="emailbtn" icon ripple v-if="item.mail">
                        <v-icon color="grey lighten-1">send</v-icon>
                    </v-btn>       
                    <v-btn @click.stop="mailclick(item)" class="emailbtn" icon ripple v-if="item.mail">
                        <v-icon color="grey lighten-1">cancel</v-icon>
                    </v-btn>
                    <v-tooltip v-if="!((item.tipo == 'Abono') && ($store.state.usuario.type=='Cliente')) && !(item.tipo == 'Tarea') " bottom>         
                        <template v-slot:activator="{ on, attrs }">  
                            <v-btn @click.stop="lastOrder(true,item.tipo,item.numero)" class="emailbtn" icon ripple v-bind="attrs" v-on="on">
                                <v-icon color="grey lighten-1">repeat</v-icon>
                            </v-btn> 
                        </template>
                        <span>Repetir</span>
                    </v-tooltip>            
                </div>  
            </template>
            <v-card>                
                <v-card-text>
                    <v-list two-line>
                        <template v-for="(line, index) in facturaActual">                            
                            <v-list-tile                            
                            :key="index"                                                        
                            >                            
                            <v-list-tile-content>                                
                                <v-list-tile-title class="small-header"><span class="secondaryText">{{line.codProducto}}</span> - {{line.descProducto}}</v-list-tile-title>                                
                                <v-list-tile-sub-title>Cantidad: {{line.cantidad}}</v-list-tile-sub-title>
                                <v-list-tile-action-text>{{line.importeTAX}} €</v-list-tile-action-text>    
                            </v-list-tile-content>                            
                            </v-list-tile>
                        </template>
                        </v-list>
                </v-card-text>
            </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>            
        </v-container>
        <!--v-flex xs12 offset-xs10>
            <v-tooltip bottom class="right">
                <template v-slot:activator="{ on }">
                    <span v-on="on"><v-btn outline fab color="green" @click="lanzaDialogCobro('')">
                        <v-icon>payment</v-icon>
                    </v-btn></span>
                </template>
                <span>Cobrar Facturas marcadas</span>
            </v-tooltip>
        </v-flex-->
    </v-flex>
</template>
<script>
import Vue from 'vue'
  export default {
      name: 'facturasPendientes',
    data () {
      return {      
          selectedClass: 'selected',
          noClass: '',
          panelIndex: null    ,
          test: false
      }
    },

    methods: {            
        toggle (item, index) {            
            this.facturas[index].selected = !this.facturas[index].selected;            
            Vue.set(this.facturas,index,item);            
        },
        onClick(item){            
            this.getInvoice(item.numero);
        },
        mailclick(item){
            item.mail = !item.mail;
            this.test = !this.test;
        },
        sendclick(item){
            this.sendDocument(item.numero,item.tipo,this.$store.state.usuario.lastEmail);
            item.mail = !item.mail;
            this.test = !this.test;
        }
        
    },
    watch: {
        panelIndex: function() {
            if (this.panelIndex != null){
                this.getInvoice(this.facturas[this.panelIndex].numero);
            } else{
                this.facturaActual = [];
            }                        
        }
    },
    computed: {     
        facturaActual: {
            get(){
                return this.$store.state.facturaActual;
            },
            set(value){
                this.$store.state.facturaActual = value;
            }
        },
        facturas: {
            get(){
                return this.$store.state.facturas;
            },
            set(value){
                this.$store.commit('setInvoices',value);
            }
        },
        selected: {
            get(){
                return this.$store.state.selectedInvIndex;
            },
            set(value){
                this.$store.commit('setSelectedInvoice',value);
            }
        },
        fechas:{
            get(){
                return this.$store.state.fechas;
            },
            set(value){
                this.$store.commit('setDates',value);   
            }
        }
    },
    mounted(){
        //this.getInvoices();        
        
    },
    updated(){
        var currentTime = new Date();
        var difference = currentTime - Date.parse(this.$store.state.usuario.lastActiveTime);
        difference = difference/60000;        
        if (difference > 30){
            this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
            this.$store.commit("logout");
        } else {
            this.$store.state.usuario.lastActiveTime = new Date().toISOString();
        }
    },
  }
</script>
<style scoped>
.right{
    float: right;
}
.selected{
    background-color: lightblue !important;
}
.primaryText{
    color : #3aa338 !important
}
.greytext{
    color : grey !important
}
.secondaryText{
    color : #cc6600 !important
}
.small-header{
    font-size: small;
}
.emailbtn{
   float: right; 
}
</style>

